<template>
  <div style="padding:10px">
    <Table :columns="tableColumns" :data="tableData.data" :loading="tableLoading" border
      style="margin:10px 0;min-height:55vh">
      <template slot-scope="{ row }" slot="name">
        <a v-if="row.instro" @click="looks(row.instro)">{{ row.name }}</a>
        <span v-else>{{ row.name }}</span>
      </template>
      <template slot-scope="{ row }" slot="index">
        {{ (tableData.current_page - 1) * 10 + row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="is_add">
        {{ row.is_add == 1 ? '是' : '否' }}
      </template>
      <template slot-scope="{ row }" slot="is_display">
        {{ row.is_display == 2 ? '是' : '否' }}
      </template>
      <template slot-scope="{ row }" slot="action">
        <!-- <Button @click="$router.push('examinationBank/paperLibrary?id='+row.id)" v-if="row.is_add == 1" type="info" size="small">查看</Button> -->
        <span v-if="row.is_add == 1">已添加</span>
        <Poptip v-auth="'admin/delete'" transfer confirm title="您确定要添加该课程吗？" @on-ok="addSure(row)">
          <Button type="primary" v-if="row.is_add != 1" size="small">添加</Button>
        </Poptip>
      </template>
    </Table>
    <Modal title="介绍" v-model="visible">
      <div v-html="contents" style="width: 100%" />
      <div slot="footer">
        <Button type="text" size="small" @click="visible = false">取消</Button>
      </div>
    </Modal>
    <Page style="text-align:right" :total="tableData.total" :page-size="tableData.per_page"
      :current="tableData.current_page" show-total @on-change="getData" />
  </div>
</template>
<script>
  import indexPage from "../../mixins/indexPage";
  export default {
    props: {
      reSearch: {
        type: Object,
        default: {
          grade_id: '',
          subject_id: ''
        }
      }
    },
    data() {
      return {
        page: {
          totlal: 10,
          currentPage: 1,
          pageSize: 10
        },
        contents: '',
        visible: false,
        tableColumns: [
          { title: "序号", slot: "index", width: 80, align: "center", },
          { title: "课程名称", slot: "name", align: "center", minWidth: 200, },
          { title: "级别", key: "grade_name", align: "center", minWidth: 140, },
          { title: "科目", key: "subject_name", align: "center", minWidth: 140, },
          { title: "是否启用", slot: "is_display", align: "center", minWidth: 140, },
          { title: "操作", slot: "action", align: "center", width: 130, },
        ],
        indexUrl: "/app/curse/all",
      };
    },
    mixins: [indexPage],
    methods: {
      search() {
        this.searchData = this.reSearch;
      },
      looks(con) {
        this.visible = true
        this.contents = con
      },
      // 购买完调用
      addSure(row) {
        let data = { course_id: row.id };
        this.$axios.post('/app/my_course/index', data).then((res) => {
          if (res.code == 1) {
            this.$Message.success('添加成功');
            this.getData(this.tableData.current_page)
          } else {
            this.$Message.info(res.msg);
          }
        })
      },
      getProfile() {
        this.$router.push({ path: '/examinationBank/profile' })
      }
    }
  };
</script>
<style scoped lang="less">
  .group-name:nth-child(n + 2)::before {
    content: " / ";
  }
  .wrapper {
    .list {
      width: 100%;
      height: 120px;
      display: flex;
      margin-top: 10px;
      border-bottom: 1px solid rgb(226, 226, 226);
      .item-content {
        width: 600px;
        text-align: center;
        .item:nth-child(1) {
          width: 100%;
          height: 60px;
          line-height: 60px;
          display: flex;
          div {
            width: 33%;
          }
        }
        .item:nth-child(2) {
          width: 100%;
          height: 60px;
          line-height: 60px;
          display: flex;
          justify-content: space-between;
          div:nth-child(1) {
            margin-left: 120px;
          }
          div:nth-child(2) {
            margin-right: 120px;
          }
          div {
            width: 100px;
            height: 30px;
            line-height: 30px;
            background: coral;
            font-size: 12px;
            color: #fff;
            cursor: pointer;
            border-radius: 4px;
          }
        }
      }
      .item-img {
        width: 300px;
        text-align: center;
        img {
          width: 140px;
          height: 100px;
        }
      }
    }
    .page {
      width: 100%;
      text-align: right;
    }
  }
</style>
